export default __webpack_public_path__ + "static/media/Icons_arrow_left-circle.00001a99.svg";